import { create } from 'zustand'
const inventoryStore = (set: any) => ({
  view: 'table',
  changeView: (newView: string) => set(() => ({ view: newView })),
})

export const myStore = create(inventoryStore)
